<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-passing-grade-major" data-bs-toggle="modal" data-bs-target="#passing-grade-major-modal-form">Klik</button>
        <div class="modal" id="passing-grade-major-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2 mb-4">
                                <div class="row">
                                    <div class="col-9">
                                        <div class="form-group">
                                            <label class="form-label">Universitas<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <v-select
                                                :options="dataUniversity"
                                                label="name"
                                                v-model="form.university"
                                                placeholder="Pilih Univertitas"
                                                @input="setCode();checkPassingGrade();getMajor();clearSubject()"
                                                >
                                                <template #search="{attributes, events}">
                                                    <input
                                                    class="vs__search"
                                                    :required="!form.university"
                                                    v-bind="attributes"
                                                    v-on="events"
                                                    />
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Kode</label>
                                            <input type="text" class="form-control" readonly="" v-model="university_code" required oninvalid="this.setCustomValidity('Masukan kode universitas')" oninput="this.setCustomValidity('')" placeholder="Kode">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Jurusan<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper">
                                        <v-select
                                                :options="dataMajor"
                                                label="major_fullname"
                                                v-model="form.major"
                                                placeholder="Pilih Jurusan"
                                                @input="checkPassingGrade"
                                                >
                                                <template #search="{attributes, events}">
                                                    <input
                                                    class="vs__search"
                                                    :required="!form.major"
                                                    v-bind="attributes"
                                                    v-on="events"
                                                    />
                                                </template>
                                            </v-select>

                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Rumpun<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper form-select-style-1">
                                        <i class="fa-solid fa-caret-down"></i>
                                        <select class="form-select form-select-box-1" v-model="form.group_subject_id" required oninvalid="this.setCustomValidity('Pilih Rumpun')" oninput="this.setCustomValidity('')" v-on:change="setSubject" disabled>
                                            <option value="">Pilih Rumpun</option>
                                            <option v-for="(item, index) in dataGroupSubject" :key="index" :value="item.id">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="card" v-if="subjectList.length > 0">
                                    <div class="d-block p-3">
                                        <div class="d-block text-sm mb-1">Mata Pelajaran Prasyarat</div>
                                        <div class="d-flex flex-wrap">
                                            <div v-for="(item, index) in subjectList" :key="index" class="d-flex align-items-center py-2 px-3 border rounded me-2 my-1 text-sm">
                                                <div class="me-2">{{ item.name }}</div>
                                                <div class="box-score box-score-sm">
                                                    <span>{{ item.score }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group form-style-1 mb-2">
                                            <label class="form-label">PM UTBK<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan nilai" v-model="form.pg_utbk" required oninvalid="this.setCustomValidity('Masukan PM UTBK')" oninput="this.setCustomValidity('')">
                                        </div>
                                        <div class="d-flex"> 
                                            <button type="button" v-if="generate_utbk == 1" class="btn btn-white-naked btn-sm" v-on:click="generatePGUTBK()"><i class="fa-solid fa-bolt me-2 text-primary"></i>Generate PM UTBK</button>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group form-style-1 mb-2">
                                            <label class="form-label">PM Rapor<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan nilai" v-model="form.pg_rapor" required oninvalid="this.setCustomValidity('Masukan PM Rapor')" oninput="this.setCustomValidity('')" disabled>
                                        </div>
                                        <div class="d-flex justify-content-end mb-4" v-if="form.major_id"> 
                                            <button type="button" class="btn btn-white-naked btn-sm" v-on:click="generatePG('utbk')"><i class="fa-solid fa-bolt me-2 text-primary"></i>Konversi dari PM UTBK</button>
                                            <button v-if="form.generate == 1" type="button" class="btn btn-white-naked btn-sm" v-on:click="generatePG('rapor')"><i class="fa-solid fa-bolt me-2 text-primary"></i>Generate PM Rapor</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-passing-grade-major">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'PassingGradeMajorForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id                  : "",
                university_id       : "",
                major_id            : "",
                group_subject_id    : "",
                pg_utbk             : "",
                pg_rapor            : "",
                generate            : 1,
                total_generate      : 0,
                university          : []
            },
            dataUniversity       : [],
            dataGroupSubject     : [],
            dataMajor            : [],
            subjectList          : [],
            university_code      : '',
            temp_passing_grade   : "",
            submitted            : false,
            waiting              : false,
            generate_utbk        : 0
        }
    },
    validations: {
        form: {
            university_id: {
                required
            },
            major_id: {
                required
            },
            group_subject_id: {
                required
            },
            pg_utbk: {
                required
            },
            pg_rapor: {
                required
            }
        }
    },
    methods: {
        loadForm: function(params="") {
            this.getUniversity();
            this.getGroupSubject();

            if(params == '') {
                this.label = 'Tambah';
                this.clearForm();
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            document.getElementById('btn-modal-passing-grade-major').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-passing-grade-major').click();
            this.$parent.$children[0].$children[0].getData();
            this.clearForm();
        },
        clearForm: function() {
            this.university_code = "";
            for (let key in this.form) {
                this.form[key] = '';

                if(key == 'generate') {
                    this.form[key] = 1;
                }

                if(key == 'group_subject_id') {
                    this.checkPassingGrade();
                    this.subjectList = [];
                    this.form.group_subject_id = "";
                }

            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    if(key == 'university' || key == 'major') {                        
                        formData.append(key, JSON.stringify(this.form[key]));
                    } else {
                        formData.append(key, this.form[key]);
                    }
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-major/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });

            }
        },
        getDataByID: function(id) {
            if(id != '') {
                let uri         = process.env.VUE_APP_APIHOST+'passing-grade-major/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets = res.data.data;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];

                                if(key == 'university') {
                                    this.setCode();
                                    this.getMajor();
                                }

                                if(key == 'group_subject_id') {
                                    this.setSubject();
                                    this.generatePGUTBK(0);
                                }
                            }
                        }
                    }
                });
            }
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getGroupSubject: function() {
            let uri         = process.env.VUE_APP_APIHOST+'group-subject/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataGroupSubject = res.data.data;
            });
        },
        getMajor: function() {
            this.dataMajor      = [];
            this.form.major     = "";
            let uri         = process.env.VUE_APP_APIHOST+'major/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000,
                    university_id : this.form.university_id,
                    filter_by_university : 1
                }
            }).then(res => {
                this.dataMajor = res.data.data;
            });
        },
        setCode: function() {
            this.form.university_id = this.form.university.id;
            this.university_code    = ""

            if(this.form.university_id == '') {
                this.university_code = ""
            } else {
                this.dataUniversity.forEach(element => {
                    if(element.id == this.form.university_id) {
                        this.university_code = element.code
                    }
                });
            }
        },
        setSubject: function() {
            if(this.form.group_subject_id == '') {
                this.subjectList = [];
            } else {
                this.dataGroupSubject.forEach(element => {
                    if(element.id == this.form.group_subject_id) {
                        this.subjectList = element.subject_list;
                    }                    
                });

            }
        },
        checkPassingGrade: function() {
            this.form.major_id = "";
            this.form.group_subject_id = "";
            if ((this.form.major !== undefined) && (this.form.major !== null) && (this.form.major !== "")) {
                this.form.major_id = this.form.major.id;
            }

            this.dataMajor.forEach(element => {
                if(element.id == this.form.major_id) {
                    this.form.group_subject_id = element.group_subject_id
                    this.setSubject();
                }
            });

            this.form.total_generate = 0;

            let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/check-passing-grade';
            this.$http.get(uri,{
                params : {
                    group            : 'rapor',
                    university_id    : this.form.university_id,
                    major_id         : this.form.major_id,
                }
            }).then(res => {
                this.form.pg_rapor = "";
                if(res.data.status) {
                    this.form.generate = 1;
                    this.temp_passing_grade = res.data.score;
                    this.form.total_generate = res.data.total_users;
                } else {
                    this.form.generate = 0;
                }
            });

            this.generatePGUTBK(0);
        },
        clearSubject: function() {
            this.form.group_subject_id = "";
            this.subjectList = [];
        },
        generatePG: function(params="") {
            if(params == 'rapor') {
                let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/check-passing-grade';
                this.$http.get(uri,{
                    params : {
                        group            : 'rapor',
                        university_id    : this.form.university_id,
                        major_id         : this.form.major_id,
                    }
                }).then(res => {
                    this.form.pg_rapor = "";
                    this.form.total_generate = 0;

                    if(res.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Berhasil',
                            text: 'Nilai berhasil di generate!',
                            confirmButtonText: 'OK',
                            showCancelButton: false
                        }).then((result) => {
                            if (result.value) {
                                this.form.pg_rapor = res.data.score;
                                this.form.total_generate = res.data.total_users;

                            }
                        });
                        
                    } else {
                        this.form.generate = 0;
                    }
                });                
            } else {
                if(this.form.pg_utbk == '') {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap masukan nilai PM UTBK',
                    });
                } else {
                    let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/check-passing-grade';
                    this.$http.get(uri,{
                        params : {
                            group       : 'utbk',
                            pg_utbk     : this.form.pg_utbk
                        }
                    }).then(res => {
                        if(res.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Berhasil',
                                text: 'Nilai berhasil di generate!',
                                confirmButtonText: 'OK',
                                showCancelButton: false
                            }).then((result) => {
                                if (result.value) {
                                    this.form.pg_rapor = res.data.score;
                                }
                            });
                        }
                    });
                }
            }
        },
        generatePGUTBK: function(params=1) {
            let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/check-passing-grade-utbk';
            this.$http.get(uri,{
                params : {
                    university_id    : this.form.university_id,
                    major_id         : this.form.major_id,
                }
            }).then(res => {
                if(params == 1) {
                    this.form.pg_utbk = "";
                    if(res.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Berhasil',
                            text: 'Nilai berhasil di generate!',
                            confirmButtonText: 'OK',
                            showCancelButton: false
                        }).then((result) => {
                            if (result.value) {
                                this.form.pg_utbk = res.data.score;
                                this.generate_utbk = 1;
                            } else {
                                this.generate_utbk = 0;
                            }
                        });                        
                    }
                } else {
                    if(res.data.status) {
                        this.generate_utbk = 1;
                    } else {
                        this.generate_utbk = 0;
                    }
                }
            });
        }
    },
}
</script>
